import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, Link as RouterLink, useParams } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import RaindropLogo from '../image/raindrop_logo.png';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    backgroundColor: '#F2F4F6',
    minHeight: '100vh',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 600,
  width: '100%',
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundColor: '#fff',
  padding: theme.spacing(12, 8),
  borderRadius: '30px',
  boxShadow: theme.customShadows.card,
}));

const steps = ['빌링키를 발급 받았습니다.', '결제정보를 저장했습니다.', '라이센스 등록이 완료되었습니다.'];

// ----------------------------------------------------------------------

export default function Success() {
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const [authKey, setAuthKey] = useState('');
  const [step, setStep] = useState(0);

  useEffect(() => {
    // console.log(params.get('customerKey'));
    // console.log(params.get('authKey'));
    // 빌링키 발급 api
    axios
      .post(
        'https://api.tosspayments.com/v1/billing/authorizations/issue',
        {
          customerKey: params.get('customerKey'),
          authKey: params.get('authKey'),
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Basic ${process.env.REACT_APP_TOSSPAYMENT_SECRET_KEY}`,
          },
        }
      )
      .then((res) => {
        console.log('빌링키 발급 성공 ', res.data);
        setStep(1);

        let licenseType = '';
        switch (sessionStorage.getItem('select_plan')) {
          case 'Basic':
            licenseType = 'raindrop_basic';
            break;
          case 'pro':
            licenseType = 'raindrop_pro';
            break;

          case 'Basic_new':
            licenseType = 'raindrop_basic_new';
            break;
          case 'pro_new':
            licenseType = 'raindrop_pro_new';
            break;
          default:
            break;
        }

        // 결제 정보 등록 NestJS api 호출 해야함.
        const paymentInfoData = {
          user_token: res.data.customerKey,
          customer_id: res.data.customerKey,
          phone_number: '',
          billing_key: res.data.billingKey,
          pay_type: JSON.stringify(res.data.card),
          use_license_type: licenseType,
          is_subscription: sessionStorage.getItem('is_subscription') || 'M',
          card_type: res.data.cardCompany,
          card_number: res.data.card.number,
          status: 1,
        };

        axios
          .post(`${process.env.REACT_APP_SERVER_URL}/user/payment`, paymentInfoData)
          .then((response) => {
            console.log('Payment registration success:', response.data);
          })
          .catch((error) => {
            console.error('Payment registration error:', error);
          });

        const sendData = {
          user_token: JSON.parse(sessionStorage.getItem('login_info')).user_token,
          license_type: licenseType,
          type: 'raindrop',
        };
        // 라이센스 등록
        axios({
          url: `${process.env.REACT_APP_SERVER_URL}/user/license`,
          method: 'post',
          data: sendData,
        })
          .then((response) => {
            setStep(2);

            console.log('License registration success:', response.data);

            // 그룹 명 등록
            axios
              .post(`${process.env.REACT_APP_SERVER_URL}/user/org`, {
                org_name: sessionStorage.getItem('org_name'),
                org_create_user_token: JSON.parse(sessionStorage.getItem('login_info')).user_token,
              })
              .then((response) => {
                console.log('org registration success:', response.data);

                // 유저 정보 업데이트
                axios
                  .post(
                    `${process.env.REACT_APP_SERVER_URL}/user/loginfo/${
                      JSON.parse(sessionStorage.getItem('login_info')).user_token
                    }`
                  )
                  .then((response) => {
                    console.log('user info update success:', response.data);
                    setStep(3);
                    sessionStorage.setItem('login_info', JSON.stringify(response.data[0][0]));
                  })
                  .catch((error) => {
                    console.error('user info update error:', error);
                  });
              })
              .catch((response) => {
                console.log('org registration ', response);
              });
          })
          .catch((error) => {
            console.log('라이센스 등록 오류', error);
          });
      })
      .catch((error) => {
        console.log('authorizations/issue : ', error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title> 결제 | RainDrop </title>
      </Helmet>

      <StyledRoot>
        <Container maxWidth="sm" style={{ display: 'flex', justifyContent: 'center' }}>
          <StyledContent>
            <Stack alignItems="center" spacing={10}>
              <div
                style={{ marginBottom: '60px', cursor: 'pointer' }}
                role="presentation"
                onClick={() => {
                  navigate('/', { replace: true });
                }}
              >
                <img src={RaindropLogo} alt="Raindrop_Logo" />
              </div>
              <Box sx={{ width: '100%' }}>
                <Stepper activeStep={step} alternativeLabel>
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Box>
            </Stack>
            <Button to="/" size="large" variant="contained" component={RouterLink}>
              메인 화면으로
            </Button>
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
